import { render, staticRenderFns } from "./ProfileTalentManagementOptions.vue?vue&type=template&id=770b8dce"
import script from "./ProfileTalentManagementOptions.vue?vue&type=script&lang=js"
export * from "./ProfileTalentManagementOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports